import { OrderManagementResource, useFuturesInfoCommon } from '@eih-netbroker/common';
import { useResource, useResourceHeaders } from '../../../../shared/services/useResource';

export const useFuturesInfo = () => {
  const orderManagementResource = useResource(OrderManagementResource);
  const { getResourceHeaderWithToken } = useResourceHeaders();

  const p = useFuturesInfoCommon({
    orderManagementResource,
    resourceHeadersWithToken: getResourceHeaderWithToken(),
  });

  return p;
};
